import dayJs from 'dayjs'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'
import { Box, Grid } from 'styled-system/jsx'
import { Avatar as AvatarComponent } from '../../../Avatar'

export function Avatar(props: {
	show?: boolean
	hide?: boolean
	lastSeen?: string
	id: string
}) {
	const isLastUpdatedOlderThan60s = () => {
		if (!props.lastSeen) return false
		const now = dayJs.utc()
		const lastUpdatedTime = dayJs.utc(props.lastSeen)
		return now.diff(lastUpdatedTime, 'second') > 60
	}

	return (
		<Grid
			width="40px"
			alignItems="center"
			opacity={!props.hide ? 1 : 0}
		>
			<Show when={true}>
				<div
					class={css({
						position: 'absolute',
						height: '8px',
						width: '8px',
						borderRadius: '50%',
						background: 'tscGreen.10',
						transform: 'translateX(2px) translateY(-16px)',
					})}
				/>
			</Show>
			<Box display={props.hide === true ? 'none' : 'block'}>
				<AvatarComponent id={props.id} />
			</Box>
		</Grid>
	)
}
